<form [formGroup]="copyForm" (ngSubmit)="onSubmit()">

  <!-- Book selector -->
  <div class="form-group">
    <label for="bookId">
      Book
      <span class="text-danger">*</span>
      <i class="fas fa-info-circle ms-1"
         data-toggle="tooltip"
         title="Select the book you want to set the number of copies for"></i>
    </label>
    <select
      class="form-control"
      id="bookId"
      formControlName="bookId"
      [class.is-invalid]="submitted && f.bookId.errors">
      <option value="">— Select a book —</option>
      <option *ngFor="let book of books" [value]="book.id">
        {{ book.title }}
        <ng-container *ngIf="book.isbn"> — {{ book.isbn }}</ng-container>
      </option>
    </select>
    <div class="invalid-feedback" *ngIf="submitted && f.bookId.errors?.required">
      Please select a book.
    </div>

    <!-- Show current quantity if already set -->
    <small class="form-text text-muted"
           *ngIf="selectedBook && selectedBook.quantity > 0">
      Current copies on record: <strong>{{ selectedBook.quantity }}</strong>
    </small>
  </div>

  <!-- Quantity input -->
  <div class="form-group mt-3">
    <label for="quantity">
      Number of Copies
      <span class="text-danger">*</span>
      <i class="fas fa-info-circle ms-1"
         data-toggle="tooltip"
         title="Enter the total number of physical copies available in the library"></i>
    </label>
    <input
      class="form-control"
      id="quantity"
      type="number"
      min="1"
      max="9999"
      formControlName="quantity"
      placeholder="e.g. 5"
      [class.is-invalid]="submitted && f.quantity.errors" />
    <div class="invalid-feedback" *ngIf="submitted && f.quantity.errors?.required">
      Quantity is required.
    </div>
    <div class="invalid-feedback" *ngIf="submitted && f.quantity.errors?.min">
      Quantity must be at least 1.
    </div>
    <div class="invalid-feedback" *ngIf="submitted && f.quantity.errors?.max">
      Quantity cannot exceed 9999.
    </div>
    <small class="form-text text-muted">
      This sets the total number of copies of the selected book in stock.
    </small>
  </div>

  <!-- Actions -->
  <div class="form-group mt-4 d-flex gap-2">
    <button
      type="submit"
      class="btn btn-outline-primary"
      [disabled]="loading">
      <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
      <i *ngIf="!loading" class="fas fa-save me-1"></i>
      {{ loading ? 'Saving...' : 'Save' }}
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
      [disabled]="loading">
      <i class="fas fa-times me-1"></i> Cancel
    </button>
  </div>

</form>